import styled from 'styled-components'

export const ButtonsWrapper = styled.div`
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
`

export const TitleAndButtonsWrapper = styled.div`
  width: 100%;
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const SaveButtonSection = styled.div`
  padding: 0;
`

export const SaveAndLaunchButtonSection = styled.div`
  padding: 0;
  flex: none;
`

export const FormContentWrapper = styled.div`
  padding: 16px;
  padding-top:0px;
  border-radius: 8px;
  background: var(--white);
  box-shadow: rgba(0, 0, 0, 0.08) 0px 8px 24px 0px;
`

export const FollowSteps = styled.span`
  font-size: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`

export const ChallengeName = styled.h5`
`

export const FormLaunchedFieldWrapper = styled.div`
`

export const FormIdeaQuestion = styled.p`
  font-weight: 500;
  font-size: 14px;
`

export const FormIdeaAnswer = styled.p`
  font-weight: 400;
  font-size: 14px;
  padding-left: 8px;
`

export const AnswerLink = styled.a`
  color: var(--primary);
  cursor: pointer;
  text-decoration: none;
`
